let routes = [{
		path: '/domain',
		name: 'domain',
		meta: {
			title: 'domain',
			noAuthRequired: true
		},
		children: [
			{
				meta:{
					title:'register',
					noAuthRequired: true
				},//充值申请
				component: 'domain/register'
			},
			{
				meta:{
					title:'checkout',
					noAuthRequired: true
				},//域名结算
				component: 'domain/checkout'
			},
			{
				meta:{
					title:'marketplace',
					noAuthRequired: true
				},//域名结算
				component: 'domain/marketplace'
			},
		],
		component: 'no-menu-layout'
	},
	{
		path: '/',
		name: 'layout',
		redirect: {
			name: 'index'
		},
		component: 'layout',
		children: [
			{
				meta:{
					title:'home'
				},
				component: 'index/index'
			},

			//财务管理
			{
				meta:{
					title:'apply'
				},//充值申请
				component: 'finance/apply'
			},
			{
				meta:{
					title:'pay'
				},//用户流水
				component: 'finance/pay'
			},
			{
				meta:{
					title:'monList'
				},//月账单
				component: 'finance/mon'
			},
			{
				meta:{
					title:'orderList'
				},//账单列表
				component: 'finance/order'
			},
      
      
			//cdn管理
			{
				meta:{title:'cret'},//证书管理
				component: 'cdn/cret'
			},
			{
				meta:{title:'domain'},//域名管理
				component: 'cdn/domain'
			},


			//腾讯云
			{
				meta:{
					title:'account'
				},//云账号
				component: 'tx/account'
			},
			{
				meta:{
					title:'accountApply'
				},//云账号申请
				component: 'tx/accountApply'
			},

			//亚马逊
			{
				meta:{
					title:'account'
				},//云账号
				component: 'aws/account'
			},
			{
				meta:{
					title:'accountApply'
				},//云账号申请
				component: 'aws/accountApply'
			},

			// 数据统计
			{
				meta:{
					title:'total'
				},
				component: 'data/day'
			},

			//站内信
			{
				meta:{
					title:'message'
				},
				component: 'data/message'
			},

			//帮助中心
			{
				meta:{
					title:'quest'
				},
				component: 'data/quest'
			},

			
			{
				meta:{
					title:'404',
					requireAuth: false
				},
				component: 'error/404'
			},

			{
				meta:{
					title:'mydomain',
					requireAuth: false
				},
				component: 'domain/list'
			},
			{
				path: 'domain/dns/:id',
				meta:{
					title:'dnsManage',
					requireAuth: false
				},
				component: 'domain/dns'
			},
			{
				meta:{
					title:'domainTemplate',
					requireAuth: false
				},
				component: 'domain/template'
			},
			{
				meta:{
					title:'domainPrice',
					requireAuth: false
				},
				component: 'domain/price'
			},
			
		]
	},
	{
		path:'/login',
		name:'login',
		meta:{
			title:'登錄页',
			noAuthRequired: true
		},
		component: 'login/index'
	},
	{
		path: '*',
		redirect: {
			name: 'index'
		}
	}
]
// 获取路由信息方法
let getRoutes = function() {
	// 生成路由详细信息
	createRoute(routes)
	return routes
}

// 自定义布局组件路径映射
let customLayoutMap = {
	'domain/register': 'empty-layout',
	'domain/checkout': 'empty-layout',
	'domain/marketplace': 'empty-layout'
}
// 自动生成路由
function createRoute(arr) {
	for (let i = 0; i < arr.length; i++) {
		if (!arr[i].component) return
		// 去除index
		let val = getValue(arr[i].component)
		// 生成name
		arr[i].name = arr[i].name || val.replace(/\//g, '_')
		// 生成apth
		arr[i].path = arr[i].path || `/${val}`
		// 自动生成component
		let componentFun = import(`../../views/${arr[i].component}.vue`)
		arr[i].component = () => componentFun
		if (arr[i].children && arr[i].children.length > 0) {
			createRoute(arr[i].children)
		}
	}
}
// 去除index
function getValue(str) {
	// str = login/index
	// 获取最後一个/索引
	let index = str.lastIndexOf('/')
	// 获取最後一个/後面的值
	let val = str.substring(index + 1, str.length)
	// 判断是不是index结尾
	if (val === 'index') {
		return str.substring(0, index)
	}
	return str
}
export default getRoutes()
